export default "__VITE_ASSET__0wfXj4yT__"